import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../../layouts/Dashboard'
import { Button, Col, Spinner, Form, Container, Row, Image } from 'react-bootstrap'
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'
import api from '../../../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../../../utils/errorApi'
import { useNavigate, useParams } from 'react-router-dom'
import { useLoading } from '../../../../hooks/LoadingContext'
import UserCircle from '../../../../assets/UserCircle.svg'

import styles from './styles.module.css'
import { IMaskInput } from 'react-imask'
import { states } from '../../../../utils/states'
import { Lock } from 'phosphor-react'
import ChangePasswordModal from '../../../../components/ChangePasswordModal'
import ConfirmationModal from '../../../../components/ConfirmationModal'

const EmpresaEditar: React.FC = () => {
  const [name, setName] = useState<string>('')
  const [brandName, setBrandName] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [state, setState] = useState<string>('')
  const [city, setCity] = useState<string>('')
  const [note, setNote] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [accountValidated, setAccountValidated] = useState<boolean>(false)

  const [showValidateModal, setShowValidateModal] = useState<boolean>(false)

  const [showChangePasswordModal, setShowChangePasswordModal] = useState<boolean>(false)

  const [profilePicture, setProfilePicture] = useState<File | null>()
  const [profilePictureUrl, setProfilePictureUrl] = useState<string>('')

  const { id } = useParams()

  const { isLoading, setIsLoading } = useLoading()
  const navigate = useNavigate()

  useEffect(() => {
    async function loadCompany() {
      try {
        const { data } = await api.get(`/admin/companies/${id}`)
        setName(data.company_name)
        setBrandName(data.brand_name)
        setPhone(data.phone)
        setState(data.state)
        setCity(data.city)
        setAccountValidated(data.account_validated)
        setNote(data.note)
        setEmail(data.user.email)
        if (data.user.profilePicture) setProfilePictureUrl(data.user.profilePicture.url)
      } catch (err) {
        toast.error(errorApi(err, 'Falha ao buscar a empresa!'))
      }
    }
    loadCompany()
  }, [id])

  const clearFileInput = (e: any) => {
    const filesData = new DataTransfer()
    e.target.files = filesData.files
  }

  const handlePictureChange = (e: any) => {
    if (e.target.files) {
      const file = e.target.files[0]
      const fileType = file.name.split('.')[1].toLowerCase()

      if (!['jpg', 'png', 'gif', 'jpeg'].includes(fileType)) {
        toast.error('A foto deve possuir formato .PNG, .JPG, .JPEG ou .GIF')
        clearFileInput(e)
        setProfilePicture(null)
        setProfilePictureUrl('')
      } else {
        setProfilePictureUrl(URL.createObjectURL(e.target.files[0]))
        setProfilePicture(e.target.files[0])
      }
    }
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)

    if (!isValidModel()) {
      toast.error('Você precisa preencher todos os campos obrigatórios!')
      setIsLoading(false)
      return
    }

    const data = new FormData()
    const model = {
      company_name: name,
      brand_name: brandName,
      phone,
      state,
      city,
      note,
      email,
    }
    data.append('data', JSON.stringify(model))
    if (profilePicture) data.append('image', profilePicture, profilePicture.name)

    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    try {
      await api.put(`/admin/companies/${id}`, data, config)
      toast.info('Empresa editada com sucesso!', {
        autoClose: 3000,
      })
      setIsLoading(false)
      navigate('/admin/empresas')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao editar a empresa! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  const handleChangeValidation = async (event: any) => {
    event.preventDefault()
    setIsLoading(true)

    try {
      let data = new FormData()
      data.append('data', JSON.stringify({ account_validated: !accountValidated }))
      await api.put(`/admin/companies/${id}`, data)
      toast.info('Empresa atualizada com sucesso!', { autoClose: 3000 })
      setIsLoading(false)
      navigate('/admin/empresas')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao invalidar a empresa! Tente novamente.'))
      setIsLoading(false)
    }
  }

  const isValidModel = () => {
    return brandName && phone && city && state && email
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Editar empresa">
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Editar empresa</h2>
        <Col style={{ textAlign: 'center' }}>
          <Image
            style={{ height: 150, width: 150, borderRadius: 12 }}
            fluid={true}
            src={profilePictureUrl || UserCircle}
          />
        </Col>
        <Col className={styles.form_container}>
          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nome*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o nome"
                value={brandName}
                onChange={(event) => setBrandName(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nome fantasia
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o nome fantasia"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Foto de perfil (opcional)
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="file"
                placeholder="Selecione a foto de perfil"
                onChange={(event) => {
                  handlePictureChange(event)
                }}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Telefone*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o telefone"
                as={IMaskInput}
                mask={[
                  { mask: '(00) 00000000' }, // para números fixos (8 dígitos)
                  { mask: '(00) 000000000' }, // para números de celular (9 dígitos)
                ]}
                value={phone}
                onChange={(event) => setPhone(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Estado*
              </Form.Label>
              <Form.Select
                className={styles.input}
                value={state}
                onChange={(event) => setState(event.target.value)}
              >
                <option value="">Selecione o estado</option>
                {states.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Cidade*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui a cidade"
                value={city}
                onChange={(event) => setCity(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nota
              </Form.Label>
              <Form.Control
                className={styles.input}
                as="textarea"
                placeholder="Digite aqui a nota"
                value={note}
                onChange={(event) => setNote(event.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                E-mail*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o e-mail"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Button
                className={styles.change_password_button}
                onClick={() => setShowChangePasswordModal(true)}
              >
                Alterar senha <Lock className={styles.lock_icon} size={16} weight={'bold'} />
              </Button>
            </Col>
          </Row>

          <Col style={{ textAlign: 'right' }}>
            {accountValidated ? (
              <Button
                className={`${styles.btn} ${styles.btn_delete}`}
                disabled={isLoading}
                onClick={() => setShowValidateModal(true)}
              >
                Invalidar empresa
              </Button>
            ) : (
              <Button
                className={`${styles.btn}`}
                variant="success"
                disabled={isLoading}
                onClick={() => setShowValidateModal(true)}
              >
                Validar empresa
              </Button>
            )}
            <Button
              className={styles.btn_submit}
              disabled={isLoading || !isValidModel()}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Editar empresa'
              )}
            </Button>
          </Col>
        </Col>
      </Container>
      <ChangePasswordModal
        show={showChangePasswordModal}
        closeModal={() => setShowChangePasswordModal(false)}
        id={id}
        role="admin"
      />
      <ConfirmationModal
        show={showValidateModal}
        message={`Tem certeza de que deseja ${accountValidated ? 'invalidar' : 'validar'} a empresa?`}
        action={handleChangeValidation}
        closeModal={() => setShowValidateModal(false)}
      ></ConfirmationModal>
    </DashboardLayout>
  )
}

export default EmpresaEditar
